export enum UserRoles {
  accountant = 'Accountant',
  admin = 'Admin',
  leadOfSystemAdministration = 'Lead of System Administration',
  ceo = 'CEO',
  deliveryManager = 'Delivery Manager',
  headOfAccountant = 'Head of Accountant',
  headOfDelivery = 'Head of Delivery',
  headOfHr = 'Head of HR',
  headOfRecruitment = 'Head of Recruitment',
  leadOfRecruitment = 'Recruitment Lead',
  hrManager = 'HR Manager',
  projectManager = 'Project Manager',
  recruiter = 'Recruiter',
  headOfLeadGeneration = 'Head of Lead Generation',
  headOfSalesAndMarketing = 'Head of Sales And Marketing',
  leadMarketingManager = 'Lead Marketing Manager',
}

const HR_DEPARTMENT = [UserRoles.hrManager, UserRoles.headOfHr];
const ACCOUNTANT_DEPARTMENT = [
  UserRoles.accountant,
  UserRoles.headOfAccountant,
];
const RECRUITMENT_DEPARTMENT = [
  UserRoles.recruiter,
  UserRoles.headOfRecruitment,
  UserRoles.leadOfRecruitment,
];
const ALL_DEPARTMENTS_HEADS = [
  UserRoles.headOfAccountant,
  UserRoles.headOfDelivery,
  UserRoles.headOfHr,
  UserRoles.headOfRecruitment,
  UserRoles.headOfSalesAndMarketing,
];
const DELIVERY_DEPARTMENT = [
  UserRoles.deliveryManager,
  UserRoles.headOfDelivery,
  UserRoles.projectManager,
];
const DELIVERY_MANAGEMENT = [
  UserRoles.deliveryManager,
  UserRoles.headOfDelivery,
];
const LINE_MANAGEMENT = [
  UserRoles.deliveryManager,
  UserRoles.headOfDelivery,
  UserRoles.headOfRecruitment,
  UserRoles.leadOfRecruitment,
  UserRoles.headOfHr,
  UserRoles.headOfSalesAndMarketing,
  UserRoles.leadMarketingManager,
  UserRoles.headOfLeadGeneration,
  UserRoles.leadOfSystemAdministration,
];
const CEO = [UserRoles.ceo];
const ADMIN = [UserRoles.admin, UserRoles.leadOfSystemAdministration];
const ALLOWED_ALL = [...Object.values(UserRoles)];

export const roles = {
  HR_DEPARTMENT,
  ACCOUNTANT_DEPARTMENT,
  RECRUITMENT_DEPARTMENT,
  ALL_DEPARTMENTS_HEADS,
  CEO,
  ADMIN,
  DELIVERY_DEPARTMENT,
  DELIVERY_MANAGEMENT,
  LINE_MANAGEMENT,
  ALLOWED_ALL,
};
